// src/hooks/useCountryNavigate.js
import { useNavigate, useParams } from 'react-router-dom';

export const useCountryNavigate = () => {
  const navigate = useNavigate();
  const { country } = useParams();

  return (to, options) => { 
    // ✅ allow navigate(-1), navigate(1), etc..
    if (typeof to === "number") {
      navigate(to);
      return;
    }

    // handle string paths
    const cleanPath = to.startsWith("/") ? to.slice(1) : to;
    navigate(`/${country}/${cleanPath}`, options);
    //  if (country) {
    //   navigate(`/${country}/${cleanPath}`, options);
    // } else {
    //   navigate(`/${cleanPath}`, options);
    // }
  };
};
